import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Typography from 'LuxKit/Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LoyaltyLandingPageLargeTile from './LoyaltyLandingPageLargeTile'
import LoyaltyLandingPageSmallTile from './LoyaltyLandingPageSmallTile'
import useLoyaltyLandingPageBenefitCopy from 'loyalty/hooks/useLoyaltyLandingPageBenefitCopy'
import { EmptyArray } from 'lib/array/arrayUtils'
import LayoutContainer from 'components/Common/LayoutContainer'
import Sheet from 'components/utils/Sheet'

const SmallTilesSection = styled.div`
  display: grid;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserBronzeBenefits(props: Props) {
  const { onActivate } = props
  const intl = useIntl()

  const isLoyaltyMember = useAppSelector(state => !!state.loyalty.account.data)

  const [loyaltyLandingPageBenefitCopy] = useLoyaltyLandingPageBenefitCopy()

  const largeTiles = useMemo(() => {
    if (!loyaltyLandingPageBenefitCopy) return EmptyArray
    return [
      loyaltyLandingPageBenefitCopy.hotel_upgrade,
      loyaltyLandingPageBenefitCopy.airport_transfer,
      loyaltyLandingPageBenefitCopy.lounge_pass,
    ].filter(tile => tile?.enabled)
  }, [loyaltyLandingPageBenefitCopy])

  const smallTiles = useMemo(() => {
    if (!loyaltyLandingPageBenefitCopy) return EmptyArray
    return [
      loyaltyLandingPageBenefitCopy.phone_support,
      loyaltyLandingPageBenefitCopy.travelshoot_credit,
      loyaltyLandingPageBenefitCopy.tour_exp_credit,
    ].filter(tile => tile?.enabled)
  }, [loyaltyLandingPageBenefitCopy])

  return <Sheet background="normal-background" padding="24 0" tabletPadding="48 0">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={48}>
        <VerticalSpacer gap={8}>
          <Heading variant="heading2" align="center">{intl.formatMessage({ id: 'R8ROHSTdxghG6SYaEdnf', defaultMessage: 'Where loyalty meets luxury', description: 'Heading for the bronze benefits section on the loyalty landing page' })}</Heading>
          {isLoyaltyMember && <BodyText variant="large" align="center">
            {intl.formatMessage({ id: '6Sm4zSEYoVgKr0NX7Byk', defaultMessage: 'Every booking brings you closer to unlocking VIP benefits, adding more luxury to every escape.', description: 'Body text for the bronze benefits section on the loyalty landing page' })}
          </BodyText>}
        </VerticalSpacer>
        <VerticalSpacer gap={48}>
          <VerticalSpacer gap={36}>
            {largeTiles.map((tile, index) => <LoyaltyLandingPageLargeTile
              reverse={index % 2 === 0}
              background="light-background"
              tile={tile}
              key={index}
            />)}
          </VerticalSpacer>
          <SmallTilesSection>
            {smallTiles.map(tile => <LoyaltyLandingPageSmallTile key={tile.image.id} tile={tile} />)}
          </SmallTilesSection>
          {onActivate && <Typography align="center">
            <TextButton kind="primary" onClick={onActivate}>
              {intl.formatMessage({ id: '5b_ngvIiCe0LfmtClDux', defaultMessage: 'Activate your free membership', description: 'Button to activate free loyalty membership on the bronze benefits section' })}
            </TextButton>
          </Typography>}
        </VerticalSpacer>
      </VerticalSpacer>
    </LayoutContainer>
  </Sheet>
}

export default LoyaltyUserBronzeBenefits
